/**
 * Ordre des vignettes caméra sur la page intervenant. LiveKit place toujours le participant local
 * en tête de liste, alors que le compositor (donc le spectateur) range les caméras par ordre
 * d'arrivée dans la room : l'invité, arrivé après le présentateur, y est en dernier. Pour que sa
 * page montre sa vignette là où le spectateur la verra, on la déplace en fin de liste.
 */
export function placeLocalCamLast<T>(tracks: readonly T[], isLocal: (track: T) => boolean): T[] {
  const local = tracks.filter(isLocal);
  if (local.length === 0) return [...tracks];
  return [...tracks.filter((track) => !isLocal(track)), ...local];
}
